import { InjectionToken } from '@angular/core';

export const COMMON_BASE_URL = new InjectionToken<string>('COMMON_BASE_URL');
